import { render, staticRenderFns } from "./CollectionOrder.vue?vue&type=template&id=1ad38c0e&scoped=true&"
import script from "./CollectionOrder.vue?vue&type=script&lang=js&"
export * from "./CollectionOrder.vue?vue&type=script&lang=js&"
import style0 from "./CollectionOrder.vue?vue&type=style&index=0&id=1ad38c0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad38c0e",
  null
  
)

export default component.exports